export const prepareCleanedPayload = (apiResponse, data) => {
  return {
    ...apiResponse,
    data: data.map((row) => {
      const updatedRow = { key: row.key };
      let hasError = false;

      Object.keys(row).forEach((fieldKey) => {
        if (['key', 'status'].includes(fieldKey)) return;

        const field = row[fieldKey];
        const error = field?.error;
        if (typeof error === 'string' && error.trim()) {
          hasError = true;
        }

        let finalValue = field?.value;

        if (
          ['teams', 'products'].includes(fieldKey) &&
          Array.isArray(finalValue)
        ) {
          finalValue = finalValue.map((item) =>
            typeof item === 'object' ? item.value : item
          );
        } else if (
          (['courier', 'sensor', 'from_location', 'to_location'].includes(
            fieldKey
          ) ||
            /^sensor_slot_\d+_name$/.test(fieldKey)) &&
          typeof finalValue === 'object'
        ) {
          finalValue = finalValue?.value;
        }

        updatedRow[fieldKey] = {
          ...field,
          value: finalValue,
          error,
        };
      });
      updatedRow.status = hasError ? 'error' : '';

      return updatedRow;
    }),
  };
};
